import React, { Component } from 'react';
import "tabler-react/dist/Tabler.css";import { Page, Card, Dimmer, Icon } from "tabler-react";

import GraficaRiesgo from "./GraficaRiesgo";
import GraficaAdeudos from "./GraficaAdeudos";
import TablaRiesgo from "./TablaRiesgo";

import  { API } from 'aws-amplify';

class PerfilAlumno extends Component {
	/*Inicializamos todas las variables*/
	constructor (props) {
		super(props);
		this.state = {
			loading: 'active',
			graficaRiesgo: [],
			tablaRiesgo: [],
			graficaAdeudos: [],
			updateTablaRiesgo: [],
			vistaGeneral: this.props.vistaGeneral !== undefined ? true : false,
			blackboard: JSON.parse(localStorage.getItem('blackboard'))
		};
	}


	componentDidMount = () => {
		if (this.state.blackboard.isBlackboard === false) {
			this.getInfoDocente()
		} else {
			this.setState({loading: ''})
		}
	}

	getInfoDocente = async () => {
		const docenteInfo = JSON.parse(localStorage.getItem('profile'));
		this.setState({loading: 'active'})
		let alumnos = [];
		let coursesFinalGrades = [];
		let payments = [];
		let cursos = [];
		let matriculas = [];
		let usuarios = [];

		for(let nivel of docenteInfo.nivel) {
			const respuestaApiAlumnos = await API.post('apiMisCursos', '/obtenerPerfilDelAlumno', {
				body: { nivel: nivel, username: docenteInfo.username, tipo: "alumnos" }
			});
			if (respuestaApiAlumnos.status) {
				let filtroAlumnos = respuestaApiAlumnos.data.matriculas;
				for (const usernames of filtroAlumnos) {
					if(isNaN(usernames)) {
						usuarios.push(usernames)
					} else {
						matriculas.push(usernames)
					}
				}

				const respuestaApiStudents = await API.post('apiMisCursos', '/obtenerPerfilDelAlumno', {
					body: { nivel: nivel, username: docenteInfo.username, alumnosInfo: respuestaApiAlumnos.data.alumnosInfo, matriculas: matriculas, tipo: "getStudent" }
				});
				if (respuestaApiStudents.status) {
					const respuestaApiFinalsGrades = await API.post('apiMisCursos', '/obtenerPerfilDelAlumno', {
						body: { nivel: nivel, username: docenteInfo.username, matriculas: matriculas, tipo: "getStudentsFinalGrades" }
					});
					if (respuestaApiFinalsGrades.status) {
						const respuestaApiPaymentsStats = await API.post('apiMisCursos', '/obtenerPerfilDelAlumno', {
							body: { nivel: nivel, username: docenteInfo.username, matriculas: matriculas, tipo: "getStudentsPaymentsStats" }
						});
						if(respuestaApiPaymentsStats.status) {
							const respuestaApiCursos = await API.post('apiMisCursos', '/obtenerPerfilDelAlumno', {
								body: { nivel: nivel, username: docenteInfo.username, cursoUnico: respuestaApiAlumnos.data.cursoUnico, tipo: "cursos" }
							});
							if(respuestaApiCursos.status) {
								Array.prototype.push.apply(alumnos, respuestaApiStudents.data.getStudent);
								Array.prototype.push.apply(coursesFinalGrades, respuestaApiFinalsGrades.data.getStudentsFinalGrades);
								Array.prototype.push.apply(payments, respuestaApiPaymentsStats.data.getStudentsPaymentsStats);
								Array.prototype.push.apply(cursos, respuestaApiCursos.data.cursos);
							}
						}
					}
				}
			}
		}
		this.getGraficaRiesgo(alumnos, coursesFinalGrades, payments)
		this.setState({loading: ''})
	}

	getGraficaRiesgo = (alumnosInfo, coursesFinalGrades, paymentsInfo) => {
			if (alumnosInfo.length > 0) {
					const tablaRiesgo = []
					const bubble = []
					let gralAcademicRiskCounters = [];
					let gralPaymentRiskCounters = [];
					let gralFinalRiskCounters = [];
					let z = 0
					let arrayPagos = []
					let arrayReprobadas = []
					for (const alumnos of alumnosInfo) {
							let minReqGrade = this.getMinGradeByLevel(alumnos.nivel);
							let corsesPast = 0
							let sumGrades = 0
							let normalMinGrade = 0
							let approved = 0
							let disapproved = 0
							let average = 0
							for (const grade of coursesFinalGrades) {
									if(grade.matricula == alumnos.matricula) {
											corsesPast++
											//  suma de calificaciones para obtener promedio
											sumGrades += grade.calificacion
											if (grade.calificacion >= normalMinGrade) {
													approved++;
											} else if (grade.calificacion < normalMinGrade) {
													disapproved++;
											}
									}
							}  
							// conteo de materias aprobadas y reprobadas
							normalMinGrade = minReqGrade / 10;
							// promedio obtenido de sus cursos anteriores
							average = sumGrades / corsesPast;
							// calculos de riesgo
							let monthDebits = 0
							let inscDebits = 0
							for (const payment of paymentsInfo) {
									if(payment.matricula == alumnos.matricula && payment.descripcion != null){
											const descripcion = payment.descripcion 
											if(payment.descripcion == 'MENSUALIDAD') {
													monthDebits += payment.countPago
											} else if( descripcion.match(/INSCRIPCION.*/)) {
													inscDebits += payment.countPago
											}
									}
							}
							let totalDebits = monthDebits + inscDebits;
							const gralAcademicRisk = this.getGralAcademicRisk(disapproved);
							const gralPaymentRisk = this.getGralPaymentRisk(totalDebits);
							const gralFinalRisk = this.getFinalRisk(gralAcademicRisk, gralPaymentRisk);
							// // Se contabilizan los riesgos generales
							if (gralAcademicRiskCounters[gralAcademicRisk]) {
									gralAcademicRiskCounters[gralAcademicRisk] ++;
							} else {
									gralAcademicRiskCounters[gralAcademicRisk] = 0;
									gralAcademicRiskCounters[gralAcademicRisk] ++;
							}
							if (gralPaymentRiskCounters[gralPaymentRisk]) {
									gralPaymentRiskCounters[gralPaymentRisk] ++;
							} else {
									gralPaymentRiskCounters[gralPaymentRisk] = 0;
									gralPaymentRiskCounters[gralPaymentRisk] ++;
							}
							if (gralFinalRiskCounters[gralFinalRisk]) {
									gralFinalRiskCounters[gralFinalRisk] ++;
							} else {
									gralFinalRiskCounters[gralFinalRisk] = 0;
									gralFinalRiskCounters[gralFinalRisk] ++;
							}

							tablaRiesgo.push({ 
								matricula: alumnos.matricula, 
								nombre: alumnos.nombres, 
								apellidos: alumnos.apellidos, 
								nivel: alumnos.nivel, 
								grupo: alumnos.grupo, 
								estatusAcademico: alumnos.estatus, 
								// estatusPlataforma: 'Activo', 
								materiasAprobadas: approved, 
								materiasReprobadas: disapproved, 
								riesgoAdeudos: totalDebits,
								riesgoAcademico: this.getRiskIcon(gralAcademicRisk), 
								riesgoFinal: this.getRiskIcon(gralFinalRisk) 
						}) 
						arrayPagos.push(totalDebits)
						arrayReprobadas.push(disapproved)
						bubble.push({ 
								pagos: totalDebits,
								reprobadas: disapproved,  
								riesgo: this.getRiskIcon(gralFinalRisk) 
							})
					}
					
					let maxPagos = Math.max.apply(Math, arrayPagos);
					let maxReprobadas = Math.max.apply(Math, arrayReprobadas);
					const filtroAlto = []
					const filtroMedio = []
					const filtroBajo = []
					let riskFinal = ''
					// filtro.push(['ID', 'Pagos', 'Reproados', 'Riesgo', 'Alumnos'])
					for (let i = 0; i <= maxPagos; i++) {
						for (let j = 0; j <= maxReprobadas; j++) {   
							let alumnosCount = 0
							for (const infoBubble of bubble) {
								if(infoBubble.pagos == i  && infoBubble.reprobadas == j){
									alumnosCount++
									riskFinal = infoBubble.riesgo
								}
							}
							if( alumnosCount > 0){
								if(this.getRiskColor(riskFinal) == 'Alto'){
									filtroAlto.push({x: i, y: j, r: alumnosCount})
								} else if(this.getRiskColor(riskFinal) == 'Medio'){
									filtroMedio.push({x: i, y: j, r: alumnosCount})
								} else if(this.getRiskColor(riskFinal) == 'Bajo'){
									filtroBajo.push({x: i, y: j, r: alumnosCount})
								}
							}
						}
					}
					const sumaTotal = (gralFinalRiskCounters.high ? gralFinalRiskCounters.high : 0) + (gralFinalRiskCounters.low ? gralFinalRiskCounters.low: 0) + (gralFinalRiskCounters.medium ? gralFinalRiskCounters.medium : 0)
					const low = (gralFinalRiskCounters.low ? gralFinalRiskCounters.low: 0) / sumaTotal * 100
					const medium = (gralFinalRiskCounters.medium ? gralFinalRiskCounters.medium : 0)  / sumaTotal * 100
					const high = (gralFinalRiskCounters.high ? gralFinalRiskCounters.high : 0 )  / sumaTotal * 100
					const pie = [Math.round(high * 100) / 100, Math.round(medium * 100) / 100, Math.round(low * 100) / 100]
					this.setState({graficaRiesgo: pie, tablaRiesgo: tablaRiesgo, graficaAdeudosAlto: filtroAlto, graficaAdeudosMedio: filtroMedio, graficaAdeudosBajo: filtroBajo})
			}
	}

	getMinGradeByLevel = (level) => {
		let minGrade = 60;
		switch (level) {
			case 'Doctorado':
					minGrade = 80;
					break;
			case 'Maestría':
					minGrade = 70;
					break;
			case 'Licenciatura':
					minGrade = 60;
					break;
		}
		return minGrade;
	}

	getGralAcademicRisk  = (rep) => {
		if (rep <= 1) {
			return "low";
		} else {
			if (rep > 1 && rep < 3) {
				return "medium";
			} else {
				return "high";
			}
		}
	}

	getGralPaymentRisk = (debits) => {
		if (debits <= 1) {
			return "low";
		} else {
			if (debits > 1 && debits < 3) {
				return "medium";
			} else {
				return "high";
			}
		}
	}

	getFinalRisk = (gralAcademicRisk, gralPaymentRisk) => {
		const values = {
			low: 0,
			medium: 1,
			high: 2
		};
		if (values[gralAcademicRisk] >= values[gralPaymentRisk]) {
			return gralAcademicRisk;
		} else {
			return gralPaymentRisk;
		}
	}

	getRiskColor = (risk) => {
		let riskColor = ''
		if(risk == "check"){
			riskColor = "Bajo";
		} else if(risk == "alert-triangle"){
			riskColor = "Medio";
		} else if(risk == "alert-circle"){
			riskColor = "Alto";
		}
		return  riskColor;
	}

	getRiskIcon = (risk) => {
		let riskIcon = ''
		//$risk_icon = "low";
		switch (risk) {
			case "low":
				riskIcon = "check";
				break;
			case "medium":
				riskIcon = "alert-triangle";
				break;
			case "high":
				riskIcon = "alert-circle";
				break;
		}
		return riskIcon;
	}

	handleClick = (e) => {
		if(typeof(e) != 'object' ){
			let risk = ''
			if(e == "2"){
				risk = "check";
			} else if(e == "1"){
				risk = "alert-triangle";
			} else if(e == "0"){
				risk = "alert-circle";
			}
			const updateTablaRiesgo = []
			const alumnosInfo = this.state.tablaRiesgo    
			for (const alumnos of alumnosInfo) {
					if(alumnos.riesgoFinal == risk){
						updateTablaRiesgo.push(alumnos)
					}
			}
			this.setState({updateTablaRiesgo :  updateTablaRiesgo })
		} else {
			const updateTablaRiesgo = []
			const alumnosInfo = this.state.tablaRiesgo  
			for (const alumnos of alumnosInfo) {
				if( alumnos.riesgoAdeudos == e.x && alumnos.materiasReprobadas == e.y){
					updateTablaRiesgo.push(alumnos)
				} 
			}
			this.setState({updateTablaRiesgo :  updateTablaRiesgo })
		}
	}

	render() {
		return (
			<>
			{ this.state.vistaGeneral === true ? (
					<Dimmer loader active={this.state.loading}>
						<GraficaRiesgo data={this.state} />
					</Dimmer>
				):(
					<Page.Content className="page-perfil-alumno">
						<Page.Title><Icon prefix="fe" name="user" />Perfil del Alumno</Page.Title>
						<div className="grid-graficas">
							<Card className="grafica-col-1 grafica-riesgo" title="Riesgo Académico del alumno" isCollapsible isFullscreenable >
								<Card.Body>
									<Dimmer loader active={this.state.loading}>
										<GraficaRiesgo data={this.state} parentCallBack={this.handleClick} />
									</Dimmer>
								</Card.Body>
							</Card>
							<Card className="grafica-col-2" title="Adeudo Financiero vs Adeudo Académico" isCollapsible isFullscreenable>
								<Card.Body>
									<Dimmer loader active={this.state.loading}>
										<GraficaAdeudos data={this.state} parentCallBack={this.handleClick}/>
									</Dimmer>
								</Card.Body>
							</Card>
						</div>
						<div id="tablaRiesgo">
						<Card className="card-div card-tabla-riesgo" title="Riesgo Académico y Financiero" isCollapsible isFullscreenable >
							<Card.Body>
								<Dimmer loader active={this.state.loading}>
									<TablaRiesgo data={this.state}/>
								</Dimmer>
							</Card.Body>
						</Card>
						</div>
					</Page.Content>
				)}
			</>
		);
	}
}

export default PerfilAlumno;